import { render, staticRenderFns } from "./BriefsListPane.vue?vue&type=template&id=78336112&scoped=true"
import script from "./BriefsListPane.vue?vue&type=script&lang=js"
export * from "./BriefsListPane.vue?vue&type=script&lang=js"
import style0 from "./BriefsListPane.vue?vue&type=style&index=0&id=78336112&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78336112",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78336112')) {
      api.createRecord('78336112', component.options)
    } else {
      api.reload('78336112', component.options)
    }
    module.hot.accept("./BriefsListPane.vue?vue&type=template&id=78336112&scoped=true", function () {
      api.rerender('78336112', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/BriefsListPane.vue"
export default component.exports